import { render, staticRenderFns } from "./BusKnowledgeTypeModal.vue?vue&type=template&id=4a6ee61b&"
import script from "./BusKnowledgeTypeModal.vue?vue&type=script&lang=js&"
export * from "./BusKnowledgeTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports